import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, of } from "rxjs";
import { Loader } from "@googlemaps/js-api-loader"

@Injectable({
  providedIn: "root",
})
export class MapsService {
  private currentApiStatus: BehaviorSubject<Boolean>;
  // obsCurrentApiStatus: Observable<Boolean>;

  constructor(private _ngZone: NgZone) {
  }

  async loadGoogleMaps() {
    return this._ngZone.run(async () => {
      const loader = new Loader({
        apiKey: "AIzaSyDb6FnpQ7wxIWK-pL8rM-Mog-D2F0LPp5o",
        version: "weekly",
        libraries: ["places"],
      });
      return await loader.load();
     });
  }
}